export const success = {
  'Day <1>{{date}}</1> at <3>{{time}}</3>':
    'Dia <1>{{date}}</1> às <3>{{time}}</3>',
  'Go back to home': 'Voltar para o início',
  Success: 'Sucesso',
  'Your session was scheduled!': 'Sua sessão foi agendada!',
};
